<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Sucursales
            <v-spacer></v-spacer>
            <v-text-field
            outlined
            dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda"
              
              hide-details
              clearable
            ></v-text-field>
            <v-btn
              style="float:right;"
              color="primary"
              dark
              class="ml-2"
              @click="modalNuevaSucursal = true"
              >Nueva sucursal</v-btn
            >
          </v-card-title>
          <v-alert v-if="mostrarErrorCarga" outlined type="error">
            Hubo un problema cargando la información, revise su conexión a internet e intente
            nuevamente.
          </v-alert>
          <v-data-table
            :loading="tableLoading"
            loading-text="Cargando... por favor espere."
            :headers="headers"
            :items="this.sucursalesList"
            :search="search"
          >
            <template #item.actions="{ item }">
              <v-btn color="blue" @click="editarSucursal(item)" class="mr-2" text rounded dark>
                Editar
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn color="red" @click="eliminarSucursal(item.ID)" rounded dark text>
                Borrar
                <v-icon small class="mr-2">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <ModalNuevaSucursal
      @muestraModalErrorEnAccion="mostrarModalErrorEnAccion($event)"
      @muestraDialogExito="mostrarDialogExito($event)"
      @cerrar-modal="cerrarModalNuevaSucursal()"
      :show="modalNuevaSucursal"
      v-if="modalNuevaSucursal"
      :sucursalPasada="objetoSucursalAEditar"
    />
    <ModalConfirmarEliminacion
      :show="dialogConfirmarEliminacion"
      v-if="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmarEliminacionSucursal()"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalNuevaSucursal from "@/components/modales/ModalNuevaSucursal.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";

export default {
  components: {
    ModalNuevaSucursal,
    ModalConfirmarEliminacion,
    ModalErrorEnAccion
  },
  data: () => ({
    mostrarErrorCarga: false,
    tableLoading: false,
    objetoSucursalAEditar: {},
    dialogConfirmarEliminacion: false,
    snackbarExito: false,
    modalNuevaSucursal: false,
    idItemABorrar: "",
    mensajeSnackbarExito: "",
    search: "",
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "",
    headers: [
      {
        text: "Nombre",
        align: "center",
        sortable: true,
        value: "NOMBRE"
      },
      {
        text: "Dirección",
        align: "center",
        sortable: true,
        value: "DIRECCION"
      },
      {
        text: "Colonia",
        align: "center",
        sortable: true,
        value: "COLONIA"
      },
      {
        text: "Celular",
        align: "center",
        sortable: true,
        value: "CELULAR"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: true,
        value: "TELEFONO"
      },
      {
        text: "Número de empleados",
        align: "center",
        sortable: true,
        value: "USUARIOS"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  async mounted() {
    const res2 = await this.obtenSucursales();
  },
  async beforeDestroy() {
    await this.destroySucursalesStore();
  },
  methods: {
    ...mapActions("sucursales", ["getSucursales", "deleteSucursales", "destroySucursalesStore"]),
    async obtenSucursales() {
      // if (this.sucursalesList.length === 0) {
      this.tableLoading = true;
      const res = await this.getSucursales();
      if (res[0]) {
        this.tableLoading = false;
        this.mostrarErrorCarga = false;
      } else if (res[1] === "errorcarga") {
        this.mostrarErrorCarga = true;
        this.tableLoading = false;
      }

      // } else {
      //   return true;
      // }
    },
    cerrarModalNuevaSucursal() {
      this.modalNuevaSucursal = false;
      this.objetoSucursalAEditar = {};
    },
    mostrarDialogExito(mensaje) {
      this.getSucursales();
      this.cerrarModalNuevaSucursal();
      this.snackbarExito = true;
      this.mensajeSnackbarExito = mensaje;
    },
    mostrarModalErrorEnAccion(mensaje) {
      this.dialogErrorEnAccion = true;
      this.mensajeErrorModalErrorEnAccion = mensaje;
    },
    async eliminarSucursal(data) {
      this.idItemABorrar = data;
      this.dialogConfirmarEliminacion = true;
    },
    editarSucursal(sucursalEditar) {
      this.objetoSucursalAEditar = sucursalEditar;
      this.modalNuevaSucursal = true;
    },
    async confirmarEliminacionSucursal() {
      const res = await this.deleteSucursales(this.idItemABorrar);
      if (res[0]) {
        this.dialogConfirmarEliminacion = false;
        this.getSucursales();
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Sucursal eliminada con éxito";
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
        this.dialogConfirmarEliminacion = false;
      }
    }
  },
  computed: {
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    })
  }
};
</script>
